<template>
	<Row>
		<Col :span="24">
			<Table :columns="columns" :data-source="gnssStats" :pagination="false">
				<template #bodyCell="{ column, record }">
					<template v-if="column.dataIndex === 'currentDatetimeBright'">
						<DateTimeDisplay :date="record.currentDatetimeBright" hide-utc format="YYYY-MM-DD HH:mm:ss" />
					</template>
					<template v-else-if="column.dataIndex === 'signals'">
						<SignalsListDisplay v-if="record.signals" :signals="record.signals" />
						<span v-else>—</span>
					</template>
				</template>
			</Table>
		</Col>
	</Row>
</template>

<script>
import { toRef, ref, watch } from 'vue';

import { Row, Col, Table } from 'ant-design-vue';

import ApiGnssVisibility from '@/api/ApiGnssVisibility';
import Consts from '@/api/Consts';

import { storeVisibilityItemInObject } from '@/stores/gnssVisibilityStore';

import MapHelpers from '@/components/map/utils/MapHelpers';

import DateTimeDisplay from '@/components/common/DateTimeDisplay.vue';
import SignalsListDisplay from '@/components/common/SignalsListDisplay.vue';


export default {
	components: { Row, Col, Table, DateTimeDisplay, SignalsListDisplay },
	props: {
		baseStationId: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const baseStationId = toRef(props, 'baseStationId');
		const gnssStats = ref([]);
		const requestData = () => {
			const value = baseStationId.value;
			if (value > 0) {
				ApiGnssVisibility.gnssVisibilitySignalsTableBaseStationGet(value, response => {
					let result = {}
					for (let item of response.items) {
						storeVisibilityItemInObject(result, item, false);
					}
					gnssStats.value = MapHelpers.getGnssStatsDisplay(ref(result), ref(true));
				});
			}
		}
		watch(baseStationId, requestData);
		requestData();
		return {
			gnssStats,
			columns: Consts.gnssVisibleSignalsTableColumnsComp,
		};
	},
}
</script>
